import { cn } from "@/lib/utils"
import { useLocalStorage } from "@/shared/hooks/use-local-storage"

import { chattingCopy } from "../config/chat-copy"

import SendIcon from "@/assets/img/live-chat/send-icon-v4.svg?react"
import SendActiveIcon from "@/assets/img/live-chat/send_active_icon.svg?react"
import CloseIcon from "@/assets/img/live-chat/close-advice.svg?react"
import TapActiveIcon from "@/assets/svg/tapToAsk/tap_active_v4.svg?react"
import TapInactiveIcon from "@/assets/svg/tapToAsk/tap_inactive_v4.svg?react"

interface ChatInputProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSend: () => void
  onKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onPreset: (preset: string) => void
  placeholder: string
  isActive: boolean
}

export function ChatInput({
  value,
  onChange,
  onSend,
  onKeyUp,
  onPreset,
  placeholder,
  isActive,
}: ChatInputProps) {
  const [presetsOpen, setPresetsOpen] = useLocalStorage<boolean>("chat-start-messages", true)

  return (
    <div className="relative shrink-0">
      {presetsOpen && (
        <div className="w-full select-none bg-dark-base py-3">
          <div className="mb-2 flex items-center justify-between px-5 font-body text-sm text-purple-light/70">
            {chattingCopy.mostPeople}
            <button
              type="button"
              onClick={() => setPresetsOpen(false)}
              className="flex [&_svg]:size-4"
            >
              <CloseIcon />
            </button>
          </div>
          <div className="no-scrollbar flex cursor-pointer gap-2 overflow-x-auto px-5">
            {chattingCopy.presets.map((q) => (
              <button
                type="button"
                key={q}
                onClick={() => onPreset(q)}
                className="whitespace-nowrap rounded-[40px] border border-purple-light/20 px-4 py-2.5 font-body text-base text-purple-light"
              >
                {q}
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="relative flex h-16 items-center justify-center gap-2">
        <input
          type="text"
          value={value}
          onChange={onChange}
          onKeyUp={onKeyUp}
          placeholder={placeholder}
          className="ml-2 h-12 w-full rounded-[36px] border-none bg-purple-light/10 py-5 pl-5 pr-[60px] font-body text-base text-purple-light caret-main-purple outline-none placeholder:text-purple-light/40"
        />
        <button
          type="button"
          onClick={onSend}
          className={cn(
            "absolute right-[70px] top-1/2 flex size-10 min-w-10 -translate-y-1/2 items-center justify-center rounded-full [&_svg]:size-6",
            isActive ? "bg-gradient-to-b from-peach to-purple-accent" : "bg-purple-light/10",
          )}
        >
          {isActive ? <SendActiveIcon /> : <SendIcon />}
        </button>
        <button
          type="button"
          onClick={() => setPresetsOpen((prev) => !prev)}
          className="mr-2 flex size-12 [&_svg]:size-12"
        >
          {presetsOpen ? <TapActiveIcon /> : <TapInactiveIcon />}
        </button>
      </div>
    </div>
  )
}
